/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import "./stye.css";

function AddServicio({ handleClick }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [formData, setFormData] = useState({
    name: "",
    notification_service_type_id: "",
    url: "",
    user: "",
    pass: "",
    port: "",
    db_name: "",
    description: "",
  });
  const [serviceTypes, setServiceTypes] = useState([]);

  const handleFormSubmit = async (data) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_services/create`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        Swal.fire("Creado!", "El servicio ha sido creado.", "success");
        handleClick("Servicios");
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        if (error.response.data.message === "Validation Error") {
          Swal.fire(
            "Error",
            "Por favor validar los datos ingresados",
            "warning"
          );
        } else if (error.response.data.message === "Insert Error") {
          Swal.fire(
            "Error",
            "Error al insertar en base de datos por favor intente mas tarde",
            "warning"
          );
        }
      } else {
        Swal.fire("Error", "Hubo un error", "error");
      }
    }
  };

  const handleFormData = (e) => {
    const { name, value } = e.target;

    setFormData((prevState) => ({
      ...prevState,
      [name]: name === "notification_service_type_id" ? Number(value) : value,
    }));
  };

  const getData = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/notification_service_types`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setServiceTypes(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <ScrollToTop />
      <div className="card-body">
        <div className="row">
          <div className="col-sm-12">
            <form
              className="form-horizontal fv-form fv-form-bootstrap"
              acceptCharset="UTF-8"
              id="formValidation"
              encType="multipart/form-data"
              noValidate="novalidate"
              onSubmit={handleSubmit(handleFormSubmit)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <div className="rootwizard">
                <ul className="nav nav-pills">
                  <li className="nav-item">
                    <a className="nav-link active" data-toggle="tap">
                      General
                    </a>
                  </li>
                </ul>
                <br />
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="tab1">
                    {/* Nombre */}
                    <div className="form-group row mb-3 ">
                      <label className="col-sm-2 control-label" htmlFor="name">
                        Nombre <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="name"
                          className={`form-control ${
                            errors.name?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.name?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.name?.type === "validate"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.name?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.name?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Nombre"
                          name="name"
                          type="text"
                          data-fv-field="name"
                          {...register("name", {
                            required: "El campo es requerido",
                            pattern: {
                              value: /^[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ\s]+$/,
                              message: "Ingresa un Nombre valido",
                            },
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.name?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="name"
                            data-fv-result="INVALID"
                          >
                            {errors.name.message}
                          </small>
                        )}
                        {errors.name?.type === "pattern" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="name"
                            data-fv-result="INVALID"
                          >
                            {errors.name.message}
                          </small>
                        )}
                        {errors.name?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="name"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.name?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="passnameword"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>

                    {/* Tipo de servicio */}
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="role_id"
                      >
                        Tipo de servicio{" "}
                        <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <select
                          className={`form-control ${
                            errors.notification_service_type_id?.type ===
                            "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.notification_service_type_id?.type ===
                            "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.notification_service_type_id?.type ===
                            "validate"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.notification_service_type_id?.type ===
                            "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.notification_service_type_id?.type ===
                            "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          name="notification_service_type_id"
                          data-fv-field="notification_service_type_id"
                          id="notification_service_type_id"
                          {...register("notification_service_type_id", {
                            required: "El campo es requerido",
                            pattern: /^(?!selected$).*$/,
                          })}
                          onChange={handleFormData}
                        >
                          <option selected="selected" value="selected">
                            Tipo de servicio
                          </option>
                          {serviceTypes.map((serviceType) => (
                            <option value={serviceType.id}>
                              {serviceType.name}
                            </option>
                          ))}
                        </select>
                        {errors.notification_service_type_id?.type ===
                          "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="notification_service_type_id"
                            data-fv-result="INVALID"
                          >
                            El campo es requerido
                          </small>
                        )}
                        {errors.notification_service_type_id?.type ===
                          "pattern" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="notification_service_type_id"
                            data-fv-result="INVALID"
                          >
                            El campo es requerido
                          </small>
                        )}
                      </div>
                    </div>

                    {/* URL */}
                    <div className="form-group row mb-3 ">
                      <label className="col-sm-2 control-label" htmlFor="url">
                        URL <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="url"
                          className={`form-control ${
                            errors.url?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.url?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.url?.type === "validate"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.url?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.url?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="URL"
                          name="url"
                          type="text"
                          data-fv-field="url"
                          {...register("url", {
                            required: "El campo es requerido",
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.url?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="url"
                            data-fv-result="INVALID"
                          >
                            {errors.url.message}
                          </small>
                        )}
                        {errors.url?.type === "pattern" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="url"
                            data-fv-result="INVALID"
                          >
                            {errors.url.message}
                          </small>
                        )}
                        {errors.url?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="url"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.yrl?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="url"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>

                    {/* Usuario */}
                    <div className="form-group row mb-3 ">
                      <label className="col-sm-2 control-label" htmlFor="user">
                        Usuario
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="user"
                          className={`form-control ${
                            errors.user?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.user?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.user?.type === "validateuser"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.user?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.user?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Usuario"
                          name="user"
                          type="text"
                          data-fv-field="user"
                          {...register("user", {
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.user?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="user"
                            data-fv-result="INVALID"
                          >
                            {errors.user.message}
                          </small>
                        )}
                        {errors.user?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="user"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.user?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="user"
                            data-fv-result="INVALID"
                          >
                            PPor favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>

                    {/* Password */}
                    <div className="form-group row mb-3 ">
                      <label className="col-sm-2 control-label" htmlFor="pass">
                        Password
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="pass"
                          className={`form-control ${
                            errors.pass?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.pass?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.pass?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.pass?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="pass"
                          name="pass"
                          type="pass"
                          data-fv-field="pass"
                          {...register("pass", {
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.pass?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="pass"
                            data-fv-result="INVALID"
                          >
                            {errors.pass.message}
                          </small>
                        )}
                        {errors.pass?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="pass"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.pass?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="pass"
                            data-fv-result="INVALID"
                          >
                            PPor favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>

                    {/* Puerto/Path */}
                    <div className="form-group row mb-3 ">
                      <label className="col-sm-2 control-label" htmlFor="port">
                        Puerto/Path
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="port"
                          className={`form-control ${
                            errors.port?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.port?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.port?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.port?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Puerto/Path"
                          name="port"
                          type="text"
                          data-fv-field="port"
                          {...register("port", {
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.port?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="port"
                            data-fv-result="INVALID"
                          >
                            {errors.port.message}
                          </small>
                        )}
                        {errors.port?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="port"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.port?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="port"
                            data-fv-result="INVALID"
                          >
                            PPor favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>

                    {/* Nombre DB */}
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="db_name"
                      >
                        Nombre DB
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="db_name"
                          className={`form-control ${
                            errors.db_name?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.db_name?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.db_name?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.db_name?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Nombre DB"
                          name="db_name"
                          type="text"
                          data-fv-field="db_name"
                          {...register("db_name", {
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.db_name?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="db_name"
                            data-fv-result="INVALID"
                          >
                            {errors.db_name.message}
                          </small>
                        )}
                        {errors.db_name?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="db_name"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.db_name?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="db_name"
                            data-fv-result="INVALID"
                          >
                            PPor favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>

                    {/* Descripción */}
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="description"
                      >
                        Descripción
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="description"
                          className={`form-control ${
                            errors.description?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.description?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.description?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.description?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Descripción"
                          name="description"
                          type="text"
                          data-fv-field="description"
                          {...register("description", {
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.description?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="description"
                            data-fv-result="INVALID"
                          >
                            {errors.description.message}
                          </small>
                        )}
                        {errors.description?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="description"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.description?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="description"
                            data-fv-result="INVALID"
                          >
                            PPor favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                  <nav>
                    <ul className="pagination pager wizard">
                      <li className="page-item previous disabled">
                        <a href="#" className="page-link">
                          Anterior
                        </a>
                      </li>
                      <li
                        className="page-item next ms-auto disabled hidden"
                        style={{ display: "none" }}
                      >
                        <a href="#" className="page-link">
                          Siguiente
                        </a>
                      </li>
                      <li className="page-item next finish ms-auto">
                        <button type="submit" className="page-link">
                          Finalizar
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddServicio;
